import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

const synechronAppsPage = PageBlueprint.make({
  params: {
    path: '/ai-apps',
    routeRef: rootRouteRef,
    // These pages render their own Header; suppress the default plugin page header.
    noHeader: true,
    loader: () => import('./components/AppsPage').then(m => <m.AppsPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'synechron-apps',
  routes: {
    root: rootRouteRef,
  },
  extensions: [synechronAppsPage],
});
